export default __webpack_public_path__ + "static/media/edit.8b7beab9.svg";